import { all } from 'redux-saga/effects';

import viewSaga from './view-saga';

export default function* rootSaga() {
  yield all([viewSaga()]);
}
